$(document).ready(function () {
  try {
    $('form.quick_order').on('submit', function (event) {
      event.preventDefault();
      var postString = '';

      $('form .form-row').each(function () {
        var id = $(this).find('input[name="id"]').val();
        var quantity = $(this).find('input[name="quantity"]').val();

        if (id != undefined && quantity != undefined) {
          postString += 'updates[' + id + ']=' + quantity + '&';
        }
      });

      postString = postString.slice(0, -1);

      $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        dataType: 'JSON',
        data: postString,
      }).done(function (data) {
        // open popup here
      });
    });
  } catch (e) {
    Rollbar.error('quick form js', e);
  }
});
